export const setCookie = (name: String, value: boolean) => {
  const exDate = new Date()
  exDate.setDate(exDate.getDate() + 365)
  const cookie = [`${name}=${value}`, `expires=${exDate.toUTCString()}`, "path='/'", 'secure=true', 'samesite=Lax']
  document.cookie = cookie.join(';')
}
